import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ONE_WEEK_IN_HOURS } from '../../../../basics/constants/common.constants';
import { EmailReminderType } from 'generated/event.types';
import useGetReminderJourneys from 'modules/events/graphql/queries/getReminderJourneys';

const useManageJourneys = () => {
  const { t } = useTranslation();
  const { data: journeys, loading: journeysLoading, refetch } = useGetReminderJourneys();
  const [openAddJourneyModal, setOpenAddJourneyModal] = useState(false);

  const handleAddJourney = () => {
    setOpenAddJourneyModal(true);
  };

  const handleJourneySaved = () => {
    refetch();
  };

  const formatSendTime = (timeInHour: number | null | undefined, format: EmailReminderType): string => {
    if (format === EmailReminderType.after_end) {
      return t('reminder_schedule_send_time_post_event');
    }

    if (format === EmailReminderType.before_start) {
      const hours = timeInHour || 0;
      if (hours === ONE_WEEK_IN_HOURS) {
        return t('reminder_schedule_send_time_1_week');
      }
      return t('reminder_schedule_send_time_hours_from_event', { hours });
    }

    return '-';
  };

  return {
    journeys,
    journeysLoading,
    openAddJourneyModal,
    setOpenAddJourneyModal,
    handleAddJourney,
    handleJourneySaved,
    formatSendTime,
    t,
  };
};

export default useManageJourneys;
